import { SmartSearchType } from '@platform/smart-search/enums/smart-search-type.enum';

export const smartSearchTypeHeadlineMap = new Map<SmartSearchType, string>([
  [SmartSearchType.NEW_PROPERTY_MAXIMUM_PRICE, 'New property mortgage search'],
  [SmartSearchType.MORTGAGE_PAY_FASTER, 'New mortgage search'],
  [SmartSearchType.MORTGAGE_BORROW_MORE, 'New mortgage search'],
  [SmartSearchType.SPEAK_TO_AN_EXPERT, 'Speak to an expert'],
]);
